<template>
  <div>
    <b-card
      no-body
      class="my-0"
      :class="{ 'card-transparent-background': type == 'register' }"
      ><b-card-header v-if="type == 'view'" class="card-header-profile-border">
        <b-row>
          <b-col> <h4>Order Numbeer</h4></b-col>
          <b-col class="text-right"
            ><h4 class="orderNumber">#{{ order_number }}</h4>
            <span :class="'orderStatusSpan ' + status + '_status'">{{
              status_str
            }}</span></b-col
          >
        </b-row>
      </b-card-header>
      <b-card-header
        v-else
        :class="{
          'card-header-profile-border':
            type == 'profile' || type == 'edit' || type == 'add',
          'card-header-form-doorder': type == 'register',
        }"
        ><h4>Package Details</h4></b-card-header
      >

      <b-card-body
        class=""
        :class="{
          'p-2': type == 'profile' || type == 'edit',
          'py-0': type == 'register',
        }"
      >
        <div class="container">
          <b-row>
            <b-col :sm="type == 'view' ? '12' : '6'">
              <b-form-group
                class="form-group-doorder"
                label="Pickup address"
                label-for="pickup_address"
                label-class="form-label-doorder"
              >
                <template v-slot:label v-if="type != 'view'">
                  Pickup address <span class="requiredIconSpan">*</span>
                </template>
                <p
                  class="error_validation_message_p"
                  v-if="invalid_pickup_address"
                >
                  Please select pickup address
                </p>
                <v-select
                  v-if="type == 'add' || type == 'edit'"
                  :options="pickup_addresses"
                  v-model="_pickup_address"
                  :name="pickup_address"
                  :title="pickup_address"
                  placeholder="Select address"
                  label="address"
                  :reduce="(item) => item.id"
                  :clearable="false"
                  required
                >
                </v-select>
                <span
                  v-if="type == 'view'"
                  class="form-control form-control-doorder"
                >
                  {{ _pickup_address }}
                </span>
              </b-form-group>
            </b-col>
            <!-- <b-col sm="6"
              ><VueCtkDateTimePicker v-model="date" />
              {{ date }}
              
            </b-col> -->
            <b-col :sm="type == 'view' ? '12' : '6'">
              <b-form-group
                class="form-group-doorder form-group-datetime-doorder"
                label="Time order is ready for collection"
                label-for="fulfilment_date"
                label-class="form-label-doorder"
              >
                <p
                  class="error_validation_message_p"
                  v-if="invalid_fulfilment_date"
                >
                  Please select date
                </p>
                <date-picker
                  v-if="type == 'add' || type == 'edit'"
                  v-model="_fulfilment_date"
                  type="datetime"
                  value-type="YYYY-MM-DD HH:mm"
                  format="DD MMM YYYY, hh:mm a"
                  :partial-update="true"
                  :confirm="true"
                  popup-class="datetime-picker-doorder"
                  input-class="form-control form-control-doorder w-100" :append-to-body="false"
                >
                  <template v-slot:icon-calendar
                    ><img
                      src="@/assets/images/doorder/calendar-filter-yellow.png"
                    />
                  </template>
                </date-picker>
                <span
                  v-if="type == 'view'"
                  class="form-control form-control-doorder"
                >
                  {{ _fulfilment_date }}
                </span>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col :sm="type == 'view' ? '12' : '6'">
              <b-form-group
                class="form-group-doorder"
                label="Package weight"
                label-for="package_weight"
                label-class="form-label-doorder"
              >
                <template v-slot:label v-if="type != 'view'">
                  Package weight <span class="requiredIconSpan">*</span>
                </template>
                <p
                  class="error_validation_message_p"
                  v-if="invalid_package_weight"
                >
                  Please select package weight
                </p>
                <v-select
                  v-if="type == 'add' || type == 'edit'"
                  :options="package_weight_list"
                  v-model="_package_weight"
                  :name="package_weight"
                  :title="package_weight"
                  placeholder="Select package weight"
                  :reduce="(item) => item.code"
                  :clearable="false"
                  required
                >
                </v-select>
                <span
                  v-if="type == 'view'"
                  class="form-control form-control-doorder"
                >
                  {{ _package_weight }}
                </span>
              </b-form-group>
            </b-col>

            <b-col :sm="type == 'view' ? '12' : '6'">
              <b-form-group
                class="form-group-doorder"
                label="Package size"
                label-for="package_size"
                label-class="form-label-doorder"
              >
                <template v-slot:label v-if="type != 'view'">
                  Package dimensions <span class="requiredIconSpan">*</span>
                </template>
                <p
                  class="error_validation_message_p"
                  v-if="invalid_package_size"
                >
                  Please select package size
                </p>
                <v-select
                  v-if="type == 'add' || type == 'edit'"
                  :options="package_size_list"
                  v-model="_package_size"
                  :name="package_size"
                  :title="package_size"
                  placeholder="Select package size"
                  :reduce="(item) => item.code"
                  :clearable="false"
                  required
                >
                </v-select>
                <span
                  v-if="type == 'view'"
                  class="form-control form-control-doorder"
                >
                  {{ _package_size }}
                </span>
              </b-form-group>
            </b-col></b-row
          >
          <b-row>
            <b-col :sm="type == 'view' ? '12' : '6'">
              <b-form-group
                class="form-group-doorder"
                label="Number of packages"
                label-for="number_packages"
                :number_packages="number_packages"
                label-class="form-label-doorder"
              >
                <b-form-input
                  v-if="type == 'add' || type == 'edit'"
                  id="number_packages"
                  class="form-control-doorder"
                  type="number"
                  min="1"
                  v-model="_number_packages"
                  :number_packages="number_packages"
                  placeholder="Enter number of packages"
                ></b-form-input>
                <span
                  v-if="type == 'view'"
                  class="form-control form-control-doorder"
                >
                  {{ _number_packages }}
                </span>
              </b-form-group>
            </b-col>
            <b-col :sm="type == 'view' ? '12' : '6'">
              <b-form-group
                class="form-group-doorder"
                label="Deliver by"
                label-for="deliver_by"
                label-class="form-label-doorder"
              >
                <template v-slot:label v-if="type != 'view'">
                  Deliver by <span class="requiredIconSpan">*</span>
                </template>
                <p class="error_validation_message_p" v-if="invalid_deliver_by">
                  Please select deliver by
                </p>
                <v-select
                  v-if="type == 'add' || type == 'edit'"
                  :options="deliver_by_list"
                  v-model="_deliver_by"
                  :name="deliver_by"
                  :title="deliver_by"
                  placeholder="Select deliver by"
                  :reduce="(item) => item.code"
                  :clearable="false"
                  required
                >
                </v-select>
                <span
                  v-if="type == 'view'"
                  class="form-control form-control-doorder"
                >
                  {{ _deliver_by }}
                </span>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row
            ><b-col md="12">
              <b-form-group
                label="Other details"
                label-for="other_details"
                :other_details="other_details"
                label-class="form-label-doorder"
              >
                <b-form-textarea
                  v-if="type == 'add' || type == 'edit'"
                  id="other_details"
                  class="form-control-doorder"
                  v-model="_other_details"
                  :other_details="other_details"
                  rows="3"
                  >{{ _other_details }}</b-form-textarea
                >
                <span
                  v-if="type == 'view'"
                  class="form-control form-control-doorder"
                >
                  {{ _other_details }}
                </span>
              </b-form-group>
            </b-col></b-row
          >
          <b-row>
            <b-col :sm="type == 'view' ? '12' : '6'">
              <b-form-group
                class="form-group-checkbox-group form-group-check-doorder"
                label="Fragile package?"
                label-for="is_fragile"
                :is_fragile="is_fragile"
                label-class="form-label-doorder"
              >
                <template v-slot:label v-if="type != 'view'">
                  Fragile package? <span class="requiredIconSpan">*</span>
                  <br />
                  <span class="labelSpan"
                    >Package will be delivered with extra care</span
                  >
                </template>
                <!-- <p
                      class="error_validation_message_p"
                      v-if="invalid_contact_through"
                    >
                      Please select payment
                    </p> -->

                <b-form-radio-group
                  v-if="type == 'add' || type == 'edit'"
                  id="is_fragile"
                  v-model="_is_fragile"
                  name="is_fragile"
                  required
                >
                  <b-form-radio value="1">Yes</b-form-radio>
                  <b-form-radio value="0">No</b-form-radio>
                </b-form-radio-group>
                <span
                  v-if="type == 'view'"
                  class="form-control form-control-doorder"
                >
                  {{ _is_fragile ? "Yes" : "No" }}
                </span>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row v-if="type == 'view'">
            <b-col :sm="type == 'view' ? '12' : '6'">
              <b-form-group
                class="form-group-doorder"
                label="QR scan status"
                label-class="form-label-doorder"
                label-for="qr_scan_status"
              >
                <span class="form-control form-control-doorder">
                  {{ qr_scan_status }}
                </span></b-form-group
              >
            </b-col>
            <b-col :sm="type == 'view' ? '12' : '6'">
              <b-form-group
                class="form-group-doorder"
                label="Available QR codes"
                label-class="form-label-doorder"
                label-for="available_qr_codes"
              >
                <!-- <span class="form-control form-control-doorder">
                  {{ available_qr_codes }}
                </span> -->
                <p v-for="(item, index) in available_qr_codes" :key="item" class="order-qr-code-link-doorder">
                  <a :href="item" target="_blank">QR code {{ index + 1 }}</a>
                </p>
              </b-form-group>
            </b-col>
          </b-row>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>
<script>
import $ from "jquery";
import moment from "moment";
import VueGoogleAutocomplete from "vue-google-autocomplete";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

export default {
  name: "PackageDetails",
  components: { VueGoogleAutocomplete, DatePicker },
  props: [
    "type",
    "order_number",
    "status",
    "status_str",
    "first_name",
    "last_name",
    "email",
    "contact_number",
    "dropoff_address",
    "dropoff_eircode",
    "dropoff_latitude",
    "dropoff_longitude",

    "invalid_first_name",
    "invalid_last_name",
    "invalid_email",
    "invalid_contact_number",
    "invalid_address",
    "invalid_post_code",

    "pickup_address",
    "pickup_latitude",
    "pickup_longitude",
    "pickup_addresses",
    "invalid_pickup_address",
    "fulfilment_date",
    "invalid_fulfilment_date",
    "package_weight",
    "package_weight_list",
    "invalid_package_weight",
    "package_size",
    "package_size_list",
    "invalid_package_size",
    "number_packages",
    "deliver_by",
    "deliver_by_list",
    "invalid_deliver_by",
    "other_details",
    "is_fragile",

    "qr_scan_status",
    "available_qr_codes",
  ],
  data() {
    return {
      autocompleteOptions: {
        componentRestrictions: {
          country: ["ie", "gb"],
        },
        types: ["postal_code"],
      },
    };
  },
  mounted() {},
  computed: {
    _pickup_address: {
      get() {
        return this.pickup_address;
      },
      set(value) {
        this.$emit("update:pickup_address", value);
      },
    },
    _fulfilment_date: {
      get() {
        return this.fulfilment_date;
      },
      set(value) {
        console.log(value);
        this.$emit("update:fulfilment_date", value);
      },
    },
    _package_weight: {
      get() {
        return this.package_weight;
      },
      set(value) {
        this.$emit("update:package_weight", value);
      },
    },
    _package_size: {
      get() {
        return this.package_size;
      },
      set(value) {
        this.$emit("update:package_size", value);
      },
    },
    _number_packages: {
      get() {
        return this.number_packages;
      },
      set(value) {
        this.$emit("update:number_packages", value);
      },
    },
    _deliver_by: {
      get() {
        return this.deliver_by;
      },
      set(value) {
        this.$emit("update:deliver_by", value);
      },
    },
    _other_details: {
      get() {
        return this.other_details;
      },
      set(value) {
        this.$emit("update:other_details", value);
      },
    },
    _is_fragile: {
      get() {
        return this.is_fragile;
      },
      set(value) {
        this.$emit("update:is_fragile", value);
      },
    },
  },
  methods: {},
};
</script>



// WEBPACK FOOTER //
// src/components/doorder/orders/order_details_components/PackageDetails.vue